import { createContext, useContext } from 'react';

const ACDictionaryContext = createContext({
  moduleStudy: {},
  activeAccountId: '',
  dictionary: [],
  selectedNode: null,
  selectedNodeAnswers: [],
  datapoints: [],
  disableAddButton: false,
});

export const useACDictionaryContext = () => useContext(ACDictionaryContext);

export default ACDictionaryContext;
